import React, { useEffect } from 'react'
import Navigation from '../../../Components/Navigation/Navigation'
import Footer from '../../../Components/Footer/Footer'
import Hero from './Sections/Hero/Hero'
import IndustryChallengesAndSolutions from './Sections/IndustryChallengesAndSolutions/IndustryChallengesAndSolutions'
import IndustryTech from './Sections/IndustryTech/IndustryTech'
import AISearch from './Sections/AISearch/AISearch'
import SpecializedServices from './Sections/SpecializedServices/SpecializedServices'
import WhyChoose from './Sections/WhyChoose/WhyChoose'
import FAQ from '../../../Components/FAQ/FAQ'
import Aos from 'aos'
import 'aos/dist/aos.css'
import t1 from '../../../assets/images/t1.png'
import t2 from '../../../assets/images/t2.png'
import t9 from '../../../assets/images/t9.png'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import Contect from '../../Home/Components/Contect'
import CaseStudies from '../../Home/Components/CaseStudies'

const TextileGarments = () => {

	useEffect(() => {
		Aos.init({
			duration: 1000,
			once: true,
			offset: 100,
		});
	}, []);

	const homeContent = {
		title: 'Textile & Garments App Development',
		description: 'Old-fashioned brands follow outdated playbooks while tech-savvy competitors offer virtual try-ons, AI styling, and seamless mobile experiences. Customers expect personalization and instant gratification—brands without digital innovation are losing them to those who deliver modern shopping experiences.',
		image: t1,
		breadcrumb: 'Textile & Garments',
		b: 'Boost Your Brand'
	}

	const industryChallengesAndSolutionsContent = {
		challengesTitle: 'The Critical Failures Crushing Traditional Textile Businesses',
		solutionsTitle: 'The Digital Solutions That Transform Fashion Businesses',
		challenges: [
			{
				title: 'Lack of Proper Supply Chain Visibility',
				description: "You're flying blind on materials and shipments. Without real-time tracking, you're firefighting instead of strategizing.",
				icon: '/images/industries/textile/01.svg',
			},
			{
				title: 'Customers Cannot Visualize Fit Before Buying',
				description: "Shoppers can't touch fabric or try sizes—return rates soar and loyalty drops.",
				icon: '/images/industries/textile/02.svg',
			},
			{
				title: 'Inventory Management Is Bleeding Your Profits',
				description: 'Dead stock grows while bestsellers stock out—poor tracking kills margins.',
				icon: '/images/industries/textile/03.svg',
			},
			{
				title: 'Quality Control Issues Are Destroying Your Brand',
				description: 'One defective batch can go viral—rebuilding trust takes years.',
				icon: '/images/industries/textile/04.svg',
			},
			{
				title: 'Your B2B Ordering Process Is Stuck in the Stone Age',
				description: 'Email spreadsheets and slow quotes lose buyers to competitors with instant, digital workflows.',
				icon: '/images/industries/textile/05.svg',
			},
		],
		solutions: [
			{
				title: 'End-to-End Supply Chain Visibility',
				description: 'Track every thread from mill to customer with real-time updates that eliminate guesswork.',
				icon: '/images/industries/textile/06.svg',
			},
			{
				title: 'Virtual Try-On Technology That Actually Works',
				description: 'Accurate sizing predictions and realistic try-ons reduce returns and boost conversion.',
				icon: '/images/industries/textile/07.svg',
			},
			{
				title: 'Intelligent Inventory That Anticipates Demand',
				description: "AI forecasts needs from sales patterns and trends—no more overstocking duds or missing bestsellers.",
				icon: '/images/industries/textile/08.svg',
			},
			{
				title: 'AI-Driven Quality Assurance Systems',
				description: 'Automated inspections catch defects before shipping—brand protection at scale.',
				icon: '/images/industries/textile/09.svg',
			},
			{
				title: 'Efficient B2B Ordering/Manufacturing Processes',
				description: 'Quotes, orders, and schedules in one platform—instant pricing and automated workflows.',
				icon: '/images/industries/textile/10.svg',
			},
		]
	}

	const industryTechContent = {
		mainTitle: 'The Game-Changing Technology Revolutionizing Fashion',
		leftHeading: 'Harnessing Advanced Technologies For Fashion App Development',
		leftParagraph: 'We bring AI trend forecasting, AR try-ons, real-time manufacturing analytics, and 3D fabric simulation together to modernize textile and garment operations end-to-end.',
		leftImage: t2,
		performanceItems: [
			{
				title: 'AI Design and Trend Forecasting',
				description: 'Algorithms analyze global fashion data to predict next-season hits and reduce risk.',
				icon: '/images/industries/textile/12.svg',
			},
			{
				title: 'AR Fitting Rooms',
				description: 'Phone-based virtual try-ons deliver accurate fit predictions and raise conversion.',
				icon: '/images/industries/textile/13.svg',
			},
			{
				title: 'Real-Time Manufacturing Analytics & Transparency',
				description: 'Dashboards expose bottlenecks and keep clients updated on production progress automatically.',
				icon: '/images/industries/textile/14.svg',
			},
			{
				title: '3D Fabric Simulation & Visualization',
				description: 'Simulate drape and motion before cutting, saving time and materials with digital testing.',
				icon: '/images/industries/textile/15.svg',
			},
		]
	};

	const aiSearchContent = {
		mainTitle: "The Complete Fashion Tech Platform You've Been Waiting For",
		sections: [
			{
				title: 'Supply Chain Management Dashboard',
				description: 'A centralized command center from raw materials to finished goods with full visibility and control.',
				image: '/images/industries/textile/t3.png',
				imageAlt: 'Supply Chain Management Dashboard',
				imagePosition: 'left',
				features: [
					'Real-time monitoring of materials, manufacturing, and delivery',
					'Supplier performance analytics with quality and delivery scorecards',
					'Automated alerts for delays, quality issues, and shortages',
					'Interactive maps of global supply chain movements',
					'Procurement/logistics cost optimization tools',
					'Integration with 3PLs and ERP systems',
				],
			},
			{
				title: 'B2B Order Management & Manufacturing Hub',
				description: 'Automate wholesale operations—quotes, orders, production schedules—in one place.',
				image: '/images/industries/textile/t4.png',
				imageAlt: 'B2B Order Management & Manufacturing Hub',
				imagePosition: 'right',
				features: [
					'Instant quotes based on live availability',
					'Digital catalogs: swatches, size charts, customization',
					'Capacity-based production scheduling',
					'Shared order tracking dashboards',
					'Automated invoicing and payments',
					'Custom approval workflows for large orders',
				],
			},
			{
				title: 'Quality Control and Inspection System',
				description: 'AI-driven inspections, digital checklists, and analytics to lock in consistent quality.',
				image: '/images/industries/textile/t5.png',
				imageAlt: 'Quality Control and Inspection System',
				imagePosition: 'left',
				features: [
					'Computer-vision fabric defect detection',
					'Photo-documented digital inspections with timestamps',
					'Statistical QC with trends and reporting',
					'Supplier scorecards and performance tracking',
					'Rejection/rework workflows with cost tracking',
					'Compliance management for standards and certifications',
				],
			},
			{
				title: 'Inventory Optimization & Demand Forecasting',
				description: 'Predictive analytics and smart replenishment to minimize dead stock and avoid stockouts.',
				image: '/images/industries/textile/t6.png',
				imageAlt: 'Inventory Optimization & Demand Forecasting',
				imagePosition: 'right',
				features: [
					'AI demand predictions from sales and market trends',
					'Seasonal/promo-based auto-reorder points',
					'Dead stock identification with markdown guidance',
					'Multi-location balancing and transfers',
					'Size curve optimization by region/demographics',
					'Live channel sync for accurate inventory',
				],
			},
			{
				title: 'Customer Size & Fit Recommendation Engine',
				description: 'Virtual fitting and personalized sizing to reduce returns and increase satisfaction.',
				image: '/images/industries/textile/t7.png',
				imageAlt: 'Customer Size & Fit Recommendation Engine',
				imagePosition: 'left',
				features: [
					'Body measurement via photos or manual input',
					'Models trained on millions of fit data points',
					'Fabric stretch/drape factors for accuracy',
					'Fit feedback loops to improve predictions',
					'Size charts optimized using return data',
					'Live fit support via customer service tools',
				],
			},
			{
				title: 'Loyalty and Rewards Management',
				description: 'Retention systems that turn one-time buyers into long-term advocates.',
				image: '/images/industries/textile/t3.png',
				imageAlt: 'Loyalty and Rewards Management',
				imagePosition: 'right',
				features: [
					'Points-based rewards with flexible redemption',
					'Personalized offers from purchase history',
					'Tiered membership benefits',
					'Referral and social sharing incentives',
					'Birthday/anniversary automated campaigns',
					'CLV and engagement analytics dashboard',
				],
			},
		],
	};

	const servicesContent = {
		title: 'The Development Expertise That Dominates Fashion Tech',
		cards: [
			{
				icon: '/images/industries/textile/16.svg',
				title: 'Custom E-Commerce & Marketplace Development',
				description: 'Scalable storefronts with refined filters, tailored recommendations, and frictionless checkout.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/textile/17.svg',
				title: 'Advanced Customer Support & Chat Systems',
				description: 'AI chatbots and live support for instant answers on sizing, orders, and recommendations.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/textile/18.svg',
				title: 'Supply Chain & Logistics Platform Development',
				description: 'End-to-end visibility for materials, production, shipping, and delivery with live alerts.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/textile/19.svg',
				title: 'AI-Powered Fit Technology and Sizing',
				description: 'ML-based size recommendations from body measurements and fit preferences.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/textile/20.svg',
				title: 'B2B Manufacturing Workflow Systems',
				description: 'Automated order processing, scheduling, and quality workflows for wholesale operations.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/textile/21.svg',
				title: 'State-of-the-Art Analytics & Business Intelligence',
				description: 'Dashboards for behavior, sales, and inventory for true, actionable insight.',
				buttonText: 'Discover More',
			},
		],
	};

	const whyChooseContent = {
		title: 'Why Fashion Industry Leaders Trust Our Development Team',
		image: t9,
		imageAlt: 'Why Choose Us for Fashion Tech Development',
		items: [
			{
				title: 'Extensive Knowledge of Textile and Garment Processes',
				desc: 'From design sketches to last-mile delivery—we understand fashion production end-to-end.',
			},
			{
				title: 'Ready-to-Use Solutions for Fashion-Specific Problems',
				desc: 'Sizing, seasonality, quality control, and complex production—solved with tailored systems.',
			},
			{
				title: 'Scalable Technology for Boutique and Enterprise',
				desc: 'Platforms that grow from startup order volumes to multinational operations.',
			},
			{
				title: 'Built for International Supply Chains',
				desc: 'Designed for global logistics, multi-vendor coordination, and cross-border compliance.',
			},
			{
				title: 'Developers Who Understand Fashion Business Models',
				desc: 'We speak wholesale margins, seasonal trends, SKU complexity, and retail dynamics.',
			},
		],
	};

	const faqContent = {
		title: 'The Essential Questions Every Fashion Brand Must Ask',
		questions: [
			{
				q: 'What can technology do to enhance our supply chain transparency?',
				a: 'Live monitoring dashboards, supplier scorecards, and automated notifications remove blind spots across your production chain.'
			},
			{
				q: 'Which virtual try-on solutions are most effective for our categories?',
				a: 'AR changing rooms and intelligent sizing personalized to your materials and size complexity.'
			},
			{
				q: 'What about complex B2B ordering and manufacturing workflow problems?',
				a: 'Instant quotes, production scheduling, and unified order tracking streamline wholesale and manufacturing.'
			},
			{
				q: 'How do you approach inventory optimization and demand forecasting?',
				a: 'Machine learning analyzes sales patterns, seasonality, and market data to predict optimal stock levels.'
			}
		]
	};

	return (
		<>
			<Navigation offer={true} />
			<Hero homeContent={homeContent} />
			<div data-aos="fade-up">
				<IndustryChallengesAndSolutions industryChallengesAndSolutionsContent={industryChallengesAndSolutionsContent} />
			</div>
			<div data-aos="fade-up">
				<IndustryTech industryTechContent={industryTechContent} />
			</div>
			<div data-aos="fade-up">
				<AISearch aiSearchContent={aiSearchContent} />
			</div>
			<div data-aos="fade-up">
				<SpecializedServices servicesContent={servicesContent} />
			</div>
			<div data-aos="fade-up">
				<WhyChoose whyChooseContent={whyChooseContent} />
			</div>
			<div data-aos="fade-up">
				<CaseStudies />
			</div>
			<div data-aos="fade-up">
				<ClientSpeak />
			</div>
			<div data-aos="fade-up">
				<GetQuote />
			</div>
			<div data-aos="fade-up">
				<FAQ faqContent={faqContent} />
			</div>
			<div data-aos="fade-up">
				<Contect />
			</div>
			<Footer />
		</>
	)
}

export default TextileGarments


